import { render, staticRenderFns } from "./ImageRenderComp.vue?vue&type=template&id=2fe4a0c0&"
import script from "./ImageRenderComp.vue?vue&type=script&lang=js&"
export * from "./ImageRenderComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports